export default __webpack_public_path__ + "fcffc23fd70e400fbacaf837d5a9c377.gltf";